import { COLOR_BLACK, COLOR_GRAY_LIGHT_2 } from '../colors.constants';

export const colorsMenuItem = {
  colorsMenuItemActiveBackground: COLOR_GRAY_LIGHT_2,
  colorsMenuItemBackground: 'transparent',
  colorMenuItemText: COLOR_BLACK,
};
